var map = {
	"./1st-place-medal.svg": "de2a",
	"./arrow-left.svg": "76d5",
	"./arrow-right.svg": "5f9b",
	"./badge.svg": "ad4d",
	"./basketball-jersey.svg": "1e4d",
	"./bold.svg": "18b7",
	"./bug.svg": "048f",
	"./calendar.svg": "276b",
	"./camera.svg": "8a64",
	"./caret-right.svg": "9e7c",
	"./check-bold.svg": "72dc",
	"./check-circle-s.svg": "676f",
	"./check-circle.svg": "db44",
	"./close-circle-s.svg": "6ac1",
	"./close.svg": "58a4",
	"./copy.svg": "5e82",
	"./crown.svg": "be99",
	"./cycling.svg": "cc9d",
	"./delete.svg": "4edd",
	"./deposit.svg": "3522",
	"./double-right.svg": "00e5",
	"./down.svg": "ef8e",
	"./edit.svg": "582c",
	"./empty-flag.svg": "4b27",
	"./environment.svg": "bb03",
	"./exclamation-circle-s.svg": "3355",
	"./exclamation-circle.svg": "12d9",
	"./expand.svg": "4e51",
	"./external-link.svg": "3e9d",
	"./eye-invisible.svg": "36dc",
	"./eye.svg": "4111",
	"./facebook.svg": "34ad",
	"./five-of-five.svg": "1828",
	"./gymnastics.svg": "a595",
	"./hotel.svg": "2458",
	"./id-card-bro.svg": "875a",
	"./image.svg": "1ea1",
	"./info-circle-s.svg": "76fd",
	"./info-circle.svg": "f7be",
	"./instagram.svg": "c1c5",
	"./italic.svg": "2054",
	"./left.svg": "2d94",
	"./line-chart.svg": "78fe",
	"./loading.svg": "1c2c",
	"./lock.svg": "d0fc",
	"./logout.svg": "8668",
	"./membership-card.svg": "d553",
	"./menu.svg": "c399",
	"./minus.svg": "40a0",
	"./more-horizontal.svg": "c175",
	"./navigation.svg": "d948",
	"./odnoklassniki.svg": "bf22",
	"./ordered-list.svg": "7619",
	"./padlock.svg": "dc9c",
	"./password.svg": "5618",
	"./plus.svg": "7aa7",
	"./pulse.svg": "ba5b",
	"./read.svg": "8e11",
	"./redo.svg": "3ec2",
	"./right.svg": "98f9",
	"./rocket.svg": "fc7b",
	"./rotate-left.svg": "a0a7",
	"./rotate-right.svg": "ab6a",
	"./running.svg": "62d2",
	"./safety-float.svg": "bafc",
	"./search.svg": "c6a2",
	"./settings.svg": "53df",
	"./shopping-bag.svg": "766d",
	"./skiing.svg": "cc66",
	"./solution.svg": "232a",
	"./star.svg": "3c2e",
	"./strike.svg": "e7ff",
	"./swimming.svg": "6404",
	"./sync.svg": "92ae",
	"./table.svg": "d7ab",
	"./team.svg": "aea7",
	"./telegram.svg": "ebde",
	"./tiktok.svg": "e32f",
	"./time-limit.svg": "a8b8",
	"./timer.svg": "555e",
	"./trophy.svg": "fbca",
	"./underline.svg": "bef9",
	"./undo.svg": "d7d3",
	"./unordered-list.svg": "7291",
	"./up.svg": "67b1",
	"./upload.svg": "5474",
	"./user-edit.svg": "2dd5",
	"./user-groups.svg": "37b1",
	"./user.svg": "be92",
	"./usergroup-add.svg": "a133",
	"./vkontakte.svg": "ac1e",
	"./walking.svg": "0fb6",
	"./warning-s.svg": "f124",
	"./warning.svg": "c026",
	"./withdrawal.svg": "56d1",
	"./youtube.svg": "5352"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "219f";